/* eslint-disable indent */
import type {Discount, Product} from '@/types/product';
import {getFormattedPrice} from '@/utils/priceFormatter';

const getPeriodText = (period: Discount['period']) => {
	if (period.duration <= 0) {
		return '';
	}

	if (period.type === 'MONTH') {
		if (period.duration === 1) {
			return `${period.duration} maand`;
		}
		return `${period.duration} maanden`;
	}

	if (period.type === 'YEAR') {
		if (period.duration === 1) {
			return `${period.duration} jaar`;
		}
		return `${period.duration} jaren`;
	}

	if (period.type === 'DAY') {
		if (period.duration === 1) {
			return `${period.duration} dag`;
		}
		return `${period.duration} dagen`;
	}

	return '';
};

export const getFormattedActionPeriod = (product: Product) => {
	if (!product.discount) {
		return '';
	}

	if (product.discount.actionDescription) {
		return product.discount.actionDescription;
	}

	const periodText = getPeriodText(product.discount.period);

	if (periodText.length === 0) {
		return '';
	}

	return `Na ${periodText} ${getFormattedPrice(product.price)}`;
};

export const getActionPeriodLabelText = (discount: Discount | null) => {
	const duration = discount?.period.duration ?? 0;

	if (duration <= 0 || discount === null) {
		return null;
	}

	switch (discount.period.type) {
		case 'DAY':
			return `${duration} dg`;
		case 'MONTH':
			return `${duration} mnd`;
		case 'YEAR':
			return `${duration} jr`;
		default:
			return null;
	}
};
